import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
import { Player } from '../../jscaip/Player';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
import { HiveRules } from './HiveRules';
export class HiveHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        // The board value is based on the number of neighbors to the queen
        const scoreZero = this.queenBeeMobility(node.gameState, Player.ZERO);
        const scoreOne = this.queenBeeMobility(node.gameState, Player.ONE);
        return PlayerNumberTable.ofSingle(scoreZero, scoreOne);
    }
    queenBeeMobility(state, player) {
        const queenBee = state.queenBeeLocation(player);
        if (queenBee.isPresent()) {
            const possibleMoves = HiveRules.get().getPossibleMovesFrom(state, queenBee.get());
            return possibleMoves.size();
        }
        else {
            return 0;
        }
    }
}
